import { gql } from '@apollo/client';

export const CREATE_FORUM_TOPIC = gql`
  mutation createForumTopic ($input: community_create_forum_topicInput!) {
    createForumTopic (input:$input) {
      message
      success
    }
  }
`;

export const CREATE_FORUM_TOPIC_COMMENT = gql`
  mutation createForumTopicComment($input: community_create_forum_topic_commentInput!) {
    createForumTopicComment(input: $input) {
      message
      success
    }
  }
`;

export const UPDATE_FORUM_TOPIC_COMMENT = gql`
  mutation updateForumTopicComment($input: community_update_forum_topic_commentInput!) {
    updateForumTopicComment(input: $input) {
      message
      success
    }
  }
`;